<script setup lang="ts">
    import BaseIcon from '@/components/BaseIcon.vue';
    import BaseButton from '@/components/BaseButton.vue';
    import BaseColorPicker from '@/components/BaseColorPicker.vue';
    import useProductStore from '@/store/product.store';
    import useConfigStore from '@/store/config.store';
    import { computed, ref, useTemplateRef } from 'vue';
    import { onClickOutside } from '@vueuse/core';
    import { storeToRefs } from 'pinia';

    const isOpen = ref(false);
    const wrapperRef = useTemplateRef('pickerWrapper');
    const { selectedProductConfiguration } = storeToRefs(useProductStore());
    const { isAdmin } = storeToRefs(useConfigStore());

    onClickOutside(wrapperRef, () => {
        isOpen.value = false;
    });

    const color = computed({
        get() {
            return selectedProductConfiguration.value.poleColor;
        },
        set(newColor: string) {
            selectedProductConfiguration.value.poleColor = newColor;
            // TODO : Implement pole color logic
        },
    });

    const colorStyle = computed(() => {
        return {
            backgroundColor: color.value,
        };
    });

    function toggleVisibility() {
        isOpen.value = !isOpen.value;
    }

    function toggleLock() {
        selectedProductConfiguration.value.isPoleColorEditable = !selectedProductConfiguration.value.isPoleColorEditable;
    }
</script>
<template>
    <div class="flex w-full flex-row items-center gap-4">
        <div
            ref="pickerWrapper"
            class="min-w-0 grow"
        >
            <BaseButton
                variant="text"
                class="flex h-14 w-full flex-row bg-white"
                @click="toggleVisibility"
            >
                <div class="flex h-full w-full flex-row items-center gap-3 p-2 text-text">
                    <BaseIcon
                        name="EyeDropperIcon"
                        variant="outlined"
                        class="h-6 w-6"
                    />
                    <span
                        class="h-8 w-16 border border-border-primary"
                        :style="colorStyle"
                    ></span>
                    <span class="font-sans text-sm font-normal"> {{ $t('background_color') }} </span>
                </div>
            </BaseButton>
            <div
                v-if="isOpen"
                class="x-0 y-0 border-border absolute z-10 rounded-md border bg-white"
            >
                <BaseColorPicker v-model="color" />
            </div>
        </div>
        <BaseButton
            v-if="isAdmin"
            :default-classes="false"
            class="mx-2 h-4 w-4 flex-none border-none hover:cursor-pointer"
            variant="text"
            @click="toggleLock"
        >
            <span class="sr-only">{{ $t('lock') }}</span>
            <BaseIcon
                name="LockClosedIcon"
                :class="[
                    'text-black',
                    !selectedProductConfiguration.isPoleColorEditable && 'opacity-100',
                    selectedProductConfiguration.isPoleColorEditable && 'opacity-30',
                ]"
            />
        </BaseButton>
    </div>
</template>
